import { BlankSlate, Box, Card, Title } from '@factorialco/deprecated-design-system'
import emptyState from 'assets/images/spending_policies/expense-alerts-empty.png'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  canCreateBudgets: boolean
  canCreateSpendingPolicies: boolean
}

const AlertsBlankState = ({ canCreateBudgets, canCreateSpendingPolicies }: Props) => {
  const { navigation } = useNavigation()

  const showUpsellBanner = canCreateBudgets || canCreateSpendingPolicies

  if (!showUpsellBanner)
    return (
      <BlankSlate
        size="small"
        illustration="check"
        title={i18n.t('budgets.detail.tabs.spendings.sidepanel.alerts.blank_state.default.title')}
        description={i18n.t(
          'budgets.detail.tabs.spendings.sidepanel.alerts.blank_state.default.description'
        )}
      />
    )

  return (
    <>
      <Box textAlign="center" gap="s16">
        <Title
          title={i18n.t('budgets.detail.tabs.spendings.sidepanel.alerts.blank_state.title')}
          description={i18n.t(
            'budgets.detail.tabs.spendings.sidepanel.alerts.blank_state.description'
          )}
          illustrationComponent={
            <Box borderRadius={{ all: 'rel333' }} flexNoShrink width="fit-content" padding="s8">
              <img
                src={emptyState}
                title={i18n.t('budgets.detail.tabs.spendings.sidepanel.alerts.blank_state.title')}
              />
            </Box>
          }
          centered
        />
      </Box>
      <Box gap="s16">
        {canCreateBudgets && (
          <Card>
            <Card.Title>
              {i18n.t('budgets.detail.tabs.spendings.sidepanel.alerts.blank_state.budget.title')}
            </Card.Title>
            <Card.Content>
              {i18n.t(
                'budgets.detail.tabs.spendings.sidepanel.alerts.blank_state.budget.description'
              )}
            </Card.Content>
            <Card.Link to={navigation.expenses.budgets.list.fullPath()}>
              {i18n.t('budgets.detail.tabs.spendings.sidepanel.alerts.blank_state.budget.link')}
            </Card.Link>
          </Card>
        )}
        {canCreateSpendingPolicies && (
          <Card>
            <Card.Title>
              {i18n.t('budgets.detail.tabs.spendings.sidepanel.alerts.blank_state.policies.title')}
            </Card.Title>
            <Card.Content>
              {i18n.t(
                'budgets.detail.tabs.spendings.sidepanel.alerts.blank_state.policies.description'
              )}
            </Card.Content>
            <Card.Link to={navigation.expenses.spendingPolicies.fullPath()}>
              {i18n.t('budgets.detail.tabs.spendings.sidepanel.alerts.blank_state.policies.link')}
            </Card.Link>
          </Card>
        )}
      </Box>
    </>
  )
}

export default AlertsBlankState
